<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-form-label>{{ signupLinkResend ? 'Get a New Sign-Up Link' : 'Forgot Password' }}</app-form-label>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="email"
			label="E-Mail, Student ID, or UUID"
			placeholder="E-Mail, Student ID, or UUID"
			autocomplete="username"
		></app-text-field>

		<app-form-submit-button [disabled]="!form.valid || loading" [loading]="loading">
			{{ signupLinkResend ? 'Send a New Sign-Up Link' : 'Send Password Reset' }}
		</app-form-submit-button>
	</form>

	<br />

	<div class="footer-links">
		<app-form-link (click)="onBack()">Back</app-form-link>
	</div>
</app-form-box>
